<div class="statsPopup" *ngIf="stats.player">
  <h5>{{ 'Team leader in this zone' | translate }}</h5>
  <h6>{{ stats.player.number }}. {{ stats.player.name }} <span>{{ stats.team ? stats.team.name : '' }}</span></h6>
  <div class="stats">
    <p class="main">{{ stats.points }} <span class="unit">{{ 'points' | translate }}</span></p>
    <p>{{ stats.shots - stats.failures }}<span> / {{ stats.shots }}</span> <span class="unit">{{ 'shots' | translate }}</span></p>
    <p>{{ stats.accuracy }} <span>%</span> <span class="unit">{{ 'accuracy' | translate }}</span></p>
  </div>
</div>